export const jiraProjectsFetchFixedCacheKey =
  "PostUsersMeJiraIntegrationsByIntegrationIdProjects-fixed-cache-key";

export const jiraCustomFieldsFetchFixedCacheKey =
  "usePostUsersMeJiraIntegrationsByIntegrationIdProjectsAndProjectIdIssueTypesIssueTypeFieldsMutation-fixed-cache-key";
